import { statusLabelMap } from '../../utils/common';

const statusFilterRenderer = (value: string) => statusLabelMap[value];

export default statusFilterRenderer;
